module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.7d0242c9.png";